<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbol"
                placeholder="交易对"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.symbol"
                  :label="item.symbol.toLocaleUpperCase()"
                  :value="item.symbol"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <span>是否启用&emsp;</span>
              <el-switch v-model="enable"> </el-switch>
            </div>
          </div>

          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button
              v-if="$hasPerm('tenant:copy_coin:add')"
              size="mini"
              type="primary"
              @click="show('新增')"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="id" prop="id" />
        <el-table-column label="交易对" prop="symbol" />
        <el-table-column label="跟单最大仓位价值" prop="maxFollowValue" />
        <el-table-column
          label="交易员各等级最大仓位价值map"
          prop="levelPositionValue"
          width="220"
        >
          <template slot-scope="scope">
            <span>{{ JSON.stringify(scope.row.levelPositionValue) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="是否启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              :disabled="!$hasPerm('tenant:copy_coin:toggle_enable')"
              @change="handleUpdateMarkStatus(scope.row.id, $event)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="$hasPerm('tenant:copy_coin:edit')"
              type="text"
              size="mini"
              @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="500px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="220px"
        >
          <el-form-item label="是否启用" prop="">
            <el-switch v-model="formData.enable"> </el-switch>
          </el-form-item>
          <el-form-item label="交易对" prop="">
            <el-select v-model="formData.symbol" clearable>
              <el-option
                v-for="item in symbolList"
                :key="item.symbol"
                :label="item.symbol.toLocaleUpperCase()"
                :value="item.symbol"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="跟单最大仓位价值" prop="">
            <el-input v-model="formData.maxFollowValue"> </el-input>
          </el-form-item>

          <div class="flex">交易员各等级最大仓位价值map</div>
          <template v-if="title == '新增'">
            <el-form-item
              :label="item.level + ''"
              prop=""
              v-for="item in levelArr"
            >
              <el-input v-model="formData.levelPositionValue[item.level]">
              </el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item
              :label="item.label + ''"
              prop=""
              v-for="item in confArr"
            >
              <el-input v-model="item.value"> </el-input>
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button
            v-if="canSaveCurrentDialog"
            type="primary"
            @click="handleSave"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      enable: true,
      symbol: "",
      symbolList: [],
      tabList: [],
      levelArr: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        enable: true,
        maxFollowValue: "",
        symbol: "",
        levelPositionValue: {},
      },
      confArr: [],
    };
  },
  computed: {
    canSaveCurrentDialog() {
      if (this.title === "新增") {
        return this.$hasPerm("tenant:copy_coin:add");
      }
      return this.$hasPerm("tenant:copy_coin:edit");
    },
  },
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    api.copytradeLevelList().then((res) => {
      if (res.code == 0) {
        this.levelArr = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .copytradeSymblList({
          symbol: this.symbol,
          enable: this.enable,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData = JSON.parse(JSON.stringify(row));
        for (const key in this.formData.levelPositionValue) {
          this.confArr.push({
            label: key,
            value: this.formData.levelPositionValue[key],
          });
        }
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        enable: true,
        maxFollowValue: "",
        symbol: "",
        levelPositionValue: {},
      };
      this.confArr = [];
    },
    handleSave() {
      let url = "copytradeConfAdd";
      if (this.title != "新增") {
        url = "copytradeConfUpdate";
        if (this.confArr && this.confArr.length > 0)
          this.confArr.forEach((i) => {
            this.formData.levelPositionValue[i.label] = i.value;
          });
      }

      api[url](this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
    handleUpdateMarkStatus(id, value) {
      let url = value ? "copytradeConfOn" : "copytradeConfOff";
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        api[url]({ id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功！");
            this.handleSearch();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
/deep/ .el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body .el-input {
  width: 220px;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
</style>
